const ENV_TYPE = process.env.REACT_APP_ENV || "prod";

const CONFIG = {
  dev: {
    API_BASE_URL: "http://localhost:3005/api",
  },

  prod: {
    API_BASE_URL: "https://api.dekhosabkuch.com/api",
  },
};

export const ENV = CONFIG[ENV_TYPE as "dev" | "prod"];